// eslint-disable-next-line owa-custom-rules/no-side-effects -- web components
export const iconBarRegistry: CustomElementRegistry = new CustomElementRegistry();
